import { render, staticRenderFns } from "./role.vue?vue&type=template&id=002dab65"
import script from "./role.vue?vue&type=script&lang=ts"
export * from "./role.vue?vue&type=script&lang=ts"
import style0 from "./role.vue?vue&type=style&index=0&id=002dab65&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports